export const countPages = (totalCount: number, limit: number) => {
  return Math.ceil(totalCount / limit);
};
